/**
 * Dev-only: показать баннер/демо обновления без смены build id.
 * Query `?crm_stale_preview=1` или sessionStorage `crm_stale_preview=1`.
 */
export function isSpaStaleUiPreviewDev(): boolean {
  if (process.env.NODE_ENV !== 'development') {
    return false
  }
  try {
    if (sessionStorage.getItem('crm_stale_preview') === '1') {
      return true
    }
  } catch {
    /* ignore */
  }
  if (typeof window === 'undefined') {
    return false
  }
  return new URLSearchParams(window.location.search).get('crm_stale_preview') === '1'
}
